"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnersApiClient = createPartnersApiClient;
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createPartnersApiClient(apiHost, options) {
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function getAllPartners(activated) {
        try {
            const queryParams = activated !== undefined ? { activated } : {};
            const response = await client.get('/v1/cooperatives', { params: queryParams });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getPartnerById(cooperativeId) {
        try {
            const response = await client.get(`/v1/cooperatives/${cooperativeId}`);
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    async function getEligibleDistributors(zipCode) {
        try {
            const queryParams = zipCode !== undefined ? { zipCode } : {};
            const response = await client.get('/v1/distributors/eligible', { params: queryParams });
            return response.data;
        }
        catch (err) {
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getAllPartners,
        getPartnerById,
        getEligibleDistributors
    };
}
